import { Clock, Mail, Phone, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { PageShell } from "../components/Layout";
import { ChapterTag, Reveal, SpotlightCard } from "../components/Motion";
import Seo from "../components/Seo";
import { PageHero } from "../components/Sections";

export default function Contact() {
  return (
    <PageShell>
      <Seo
        title="Contact Xtreme Protection | 24/7 UK Security Services"
        description="Contact Xtreme Protection: call +44 2046 402840 or email admin@xtremeprotection.uk. SIA-licensed security guard services across 210+ UK towns and cities, 24/7."
        path="/contact"
      />
      <PageHero
        eyebrow="CONTACT // 24/7 UK COMMAND"
        lines={["CONTACT", "COMMAND"]}
        intro={[
          "Speak directly with our UK command team about security guard services, patrols, CCTV monitoring, event security or any of our 17 specialist services — anywhere in the United Kingdom.",
          "Urgent requirement? Officers can typically be deployed within 24 hours, nationwide.",
        ]}
        breadcrumb={[{ label: "Home", path: "/" }, { label: "Contact", path: "/contact" }]}
      />

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="contact-page">
        <ChapterTag num="01" title="DIRECT LINES" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Reveal>
            <a href="tel:+442046402840" data-testid="contact-phone-link" className="block h-full group">
              <SpotlightCard className="h-full p-8 sm:p-10 hover:border-amber/60 transition-colors duration-300">
                <div className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-gray-500">
                  <Phone className="w-4 h-4 text-amber" /> Phone — 24/7 Response
                </div>
                <p className="mt-5 font-display font-black uppercase tracking-tight text-3xl sm:text-5xl text-white group-hover:text-amber transition-colors">
                  +44 2046 402840
                </p>
                <p className="mt-4 text-sm text-gray-400 leading-relaxed">
                  For urgent deployments, incident escalation and new contracts — answered around the clock.
                </p>
              </SpotlightCard>
            </a>
          </Reveal>
          <Reveal delay={0.1}>
            <a href="mailto:admin@xtremeprotection.uk" data-testid="contact-email-link" className="block h-full group">
              <SpotlightCard className="h-full p-8 sm:p-10 hover:border-amber/60 transition-colors duration-300">
                <div className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-gray-500">
                  <Mail className="w-4 h-4 text-amber" /> Email — Quotes & Enquiries
                </div>
                <p className="mt-5 font-display font-black uppercase tracking-tight text-2xl sm:text-4xl text-white group-hover:text-amber transition-colors break-all">
                  admin@xtremeprotection.uk
                </p>
                <p className="mt-4 text-sm text-gray-400 leading-relaxed">
                  For quotes, site surveys, contract discussions and general enquiries — we reply promptly.
                </p>
              </SpotlightCard>
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mt-6 border border-white/10 bg-card px-6 py-5 flex flex-wrap items-center gap-x-8 gap-y-3" data-testid="contact-assurances">
            <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-gray-400">
              <Clock className="w-3.5 h-3.5 text-amber" /> 24/7/365 UK Command Centre
            </span>
            <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-gray-400">
              <ShieldCheck className="w-3.5 h-3.5 text-amber" /> SIA Licensed & BS 7858 Vetted
            </span>
            <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-gray-400">
              <ShieldCheck className="w-3.5 h-3.5 text-amber" /> Deployment Within 24 Hours
            </span>
          </div>
        </Reveal>

        <div className="mt-14">
          <ChapterTag num="02" title="BEFORE YOU CALL" />
          <p className="max-w-3xl text-sm sm:text-base text-gray-400 leading-relaxed">
            Want to check coverage first? Enter your town or postcode in the{" "}
            <Link to="/" className="text-amber underline underline-offset-4 hover:text-white transition-colors">
              coverage checker
            </Link>
            , browse{" "}
            <Link to="/services" className="text-amber underline underline-offset-4 hover:text-white transition-colors">
              all 17 security services
            </Link>
            , or find your{" "}
            <Link to="/locations" className="text-amber underline underline-offset-4 hover:text-white transition-colors">
              local security page
            </Link>
            .
          </p>
        </div>
      </section>
    </PageShell>
  );
}
